// context/PageControlContext.js
// context/PageControlContext.js
import React, { createContext, useContext, useState } from 'react';
import { activePages } from '../pageConfig';

const PageControlContext = createContext();

export const PageControlProvider = ({ children }) => {

  const [currentPage, setCurrentPage] = useState('home');

  const [canGoBack, setCanGoBack] = useState(true);
  const [canContinue, setCanContinue] = useState(true);

  const currentIndex = activePages.indexOf(currentPage);

  const goNext = () => {
    if (currentIndex < activePages.length - 1) {
      setCurrentPage(activePages[currentIndex + 1]);
    }
  };

  const goBack = () => {
    if (currentIndex > 0) {
      setCurrentPage(activePages[currentIndex - 1]);
    }
  };

  return (
    <PageControlContext.Provider
      value={{
        currentPage,
        setCurrentPage,
        canGoBack,
        setCanGoBack,
        canContinue,
        setCanContinue,
        goNext,
        goBack
      }}
    >
      {children}
    </PageControlContext.Provider>
  );
};

export const usePageControl = () => useContext(PageControlContext);
